import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doTrackSearchBoxSelected),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadPanelData),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doTrackSearchPanelItemSelection),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doSearchPanelItemSelected),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doSearchPanelRemoveHistoryItem),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(doAutocomplete),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(setActivityKeyword),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSearchBoxSagas);

import * as logger from 'universal-logger';
import { fetchEntityIfNeeded, fetchEntity } from '@classpass/saga-tools';
import { fork, call, takeEvery, takeLatest, put, select, spawn } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push as updatePath } from 'react-router-redux';
import { keywordAutocomplete, searchLayoutByName, searchLocationAutocomplete } from 'redux/saga/entities/bound';
import { errorActionCreator, getUserId } from 'redux/saga/helpers';
import { userId as userIdSelector } from 'redux/saga/selectors/user';
import { isBlank } from 'helpers/verify';
import { pathSelector } from 'redux/saga/selectors';
import { browserHistory } from 'react-router';
import { SearchLocation } from 'features/Search/models/SearchLocation';
import { searchFilterActions } from 'features/Search/filters/filters.helpers';
import { FILTER_NAMES, HEADER_LAYOUT } from 'features/Search/Search.constants';
import { ec } from 'helpers/multitrack';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { selectActiveLocation, selectKeywordSearchBoxText, selectLocationSearchBoxText, selectOpenPanel, setLocationKey, setKeyword, setKeywordKey, setSelectedLocation, SET_OPEN_PANEL, SET_KEYWORD_VALUE, SET_LOCATION_VALUE } from './SearchBox.reducer';
import { EVENTS, ITEM_TYPES, PANEL_NAMES } from './SearchBox.constants';
import { getUserLocationForSearch, selectDataFromResultsLayout, selectKeywordAutocompleteValueInLayout } from '../Search.helpers';
import { PATH as SEARCH_PATH } from '../Search.route';
var clearFilter = searchFilterActions.clearFilter,
    setFilterValue = searchFilterActions.setFilterValue;
var SEARCHBOX_ERROR = 'SEARCHBOX_ERROR';
var SEARCH_PANEL_ITEM_SELECTED = 'SEARCH_PANEL_ITEM_SELECTED';
var SEARCH_PANEL_REMOVE_HISTORY_ITEM = 'SEARCH_PANEL_REMOVE_HISTORY_ITEM';
export var searchPanelItemSelected = function searchPanelItemSelected(panel, item) {
  return {
    type: SEARCH_PANEL_ITEM_SELECTED,
    panel: panel,
    item: item
  };
};
export var removeSearchboxHistoryItem = function removeSearchboxHistoryItem(itemType, itemId) {
  return {
    type: SEARCH_PANEL_REMOVE_HISTORY_ITEM,
    itemType: itemType,
    itemId: itemId
  };
};
export var searchBoxError = errorActionCreator.bind(null, SEARCHBOX_ERROR);
export function doTrackSearchBoxSelected(optimizelyEventTrackingName) {
  var openPanel;
  return regeneratorRuntime.wrap(function doTrackSearchBoxSelected$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectOpenPanel);

        case 2:
          openPanel = _context.sent;

          if (!(openPanel === PANEL_NAMES.location)) {
            _context.next = 11;
            break;
          }

          _context.next = 6;
          return call(ec, EVENTS.clickLocationBox);

        case 6:
          if (!optimizelyEventTrackingName) {
            _context.next = 9;
            break;
          }

          _context.next = 9;
          return spawn(trackOptimizelyEvent, "".concat(optimizelyEventTrackingName, " (location box)"));

        case 9:
          _context.next = 17;
          break;

        case 11:
          if (!(openPanel === PANEL_NAMES.keyword)) {
            _context.next = 17;
            break;
          }

          _context.next = 14;
          return call(ec, EVENTS.clickKeywordBox);

        case 14:
          if (!optimizelyEventTrackingName) {
            _context.next = 17;
            break;
          }

          _context.next = 17;
          return spawn(trackOptimizelyEvent, "".concat(optimizelyEventTrackingName, " (keyword box)"));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doLoadPanelData(client) {
  var force,
      _ref,
      lat,
      lon,
      method,
      _args2 = arguments;

  return regeneratorRuntime.wrap(function doLoadPanelData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          force = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
          _context2.next = 3;
          return select(getUserLocationForSearch);

        case 3:
          _ref = _context2.sent;
          lat = _ref.lat;
          lon = _ref.lon;
          method = force ? fetchEntity : fetchEntityIfNeeded;
          _context2.next = 9;
          return call(method, searchLayoutByName, [client, HEADER_LAYOUT, {
            header_request: {
              location: {
                lat: lat,
                lon: lon
              }
            }
          }]);

        case 9:
          return _context2.abrupt("return", _context2.sent);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doTrackSearchPanelItemSelection(panel, item) {
  var keywordSearchBoxText, locationSearchBoxText;
  return regeneratorRuntime.wrap(function doTrackSearchPanelItemSelection$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!item) {
            _context3.next = 15;
            break;
          }

          if (!(panel === PANEL_NAMES.keyword)) {
            _context3.next = 9;
            break;
          }

          _context3.next = 4;
          return select(selectKeywordSearchBoxText);

        case 4:
          keywordSearchBoxText = _context3.sent;
          _context3.next = 7;
          return call(ec, EVENTS.selectKeyword, {
            keyword_box_text: keywordSearchBoxText,
            header_type: item.type
          });

        case 7:
          _context3.next = 15;
          break;

        case 9:
          if (!(panel === PANEL_NAMES.location)) {
            _context3.next = 15;
            break;
          }

          _context3.next = 12;
          return select(selectLocationSearchBoxText);

        case 12:
          locationSearchBoxText = _context3.sent;
          _context3.next = 15;
          return call(ec, EVENTS.selectLocation, {
            location_box_text: locationSearchBoxText,
            header_type: item.type
          });

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doSearchPanelItemSelected(client, _ref2) {
  var panel, panelItem, item, studioDetailTab, _ref3, placeData, userId, currentPath;

  return regeneratorRuntime.wrap(function doSearchPanelItemSelected$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          panel = _ref2.panel, panelItem = _ref2.item;
          item = Object.assign({}, panelItem);

          if (!(panel === PANEL_NAMES.keyword)) {
            _context4.next = 27;
            break;
          }

          if (item) {
            _context4.next = 7;
            break;
          }

          console.log('Got request to clear keyword'); // eslint-disable-line no-console

          _context4.next = 25;
          break;

        case 7:
          if (!(item.type === ITEM_TYPES.venue)) {
            _context4.next = 14;
            break;
          }

          _context4.next = 10;
          return call(window.open, "/studios/".concat(item.alias), '_blank');

        case 10:
          studioDetailTab = _context4.sent;
          studioDetailTab.opener = null;
          _context4.next = 25;
          break;

        case 14:
          if (!(item.type === ITEM_TYPES.activity)) {
            _context4.next = 22;
            break;
          }

          if (!item.vertical) {
            _context4.next = 18;
            break;
          }

          _context4.next = 18;
          return put(setFilterValue(FILTER_NAMES.VERTICAL, item.vertical));

        case 18:
          _context4.next = 20;
          return put(setKeyword(item));

        case 20:
          _context4.next = 25;
          break;

        case 22:
          if (!(item.type === ITEM_TYPES.links && item.to)) {
            _context4.next = 25;
            break;
          }

          _context4.next = 25;
          return call(browserHistory.push, item.to);

        case 25:
          _context4.next = 50;
          break;

        case 27:
          if (!(panel === PANEL_NAMES.location)) {
            _context4.next = 50;
            break;
          }

          if (item) {
            _context4.next = 32;
            break;
          }

          console.log('Got request to clear location'); // eslint-disable-line no-console

          _context4.next = 50;
          break;

        case 32:
          if (!(!item.lat || !item.lon)) {
            _context4.next = 40;
            break;
          }

          _context4.next = 35;
          return call(client.search.location.details, item.place_id);

        case 35:
          _ref3 = _context4.sent;
          placeData = _ref3.data;
          item.lat = placeData.lat;
          item.lon = placeData.lon;
          item.timezone = placeData.timezone;

        case 40:
          _context4.next = 42;
          return put(setSelectedLocation(new SearchLocation(item)));

        case 42:
          _context4.next = 44;
          return put(clearFilter(FILTER_NAMES.RADIUS));

        case 44:
          _context4.next = 46;
          return call(getUserId, client);

        case 46:
          userId = _context4.sent;

          if (!userId) {
            _context4.next = 50;
            break;
          }

          _context4.next = 50;
          return spawn(client.search.location.saveForUser, userId, item.place_id);

        case 50:
          _context4.next = 52;
          return put(searchLayoutByName.resetAction({
            key: HEADER_LAYOUT
          }));

        case 52:
          if (!(item && item.type !== ITEM_TYPES.venue && item.type !== ITEM_TYPES.links)) {
            _context4.next = 59;
            break;
          }

          _context4.next = 55;
          return select(pathSelector);

        case 55:
          currentPath = _context4.sent;

          if (!(currentPath.indexOf(SEARCH_PATH) !== 0)) {
            _context4.next = 59;
            break;
          }

          _context4.next = 59;
          return put(updatePath(SEARCH_PATH));

        case 59:
          _context4.next = 61;
          return spawn(doTrackSearchPanelItemSelection, panel, item);

        case 61:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function doSearchPanelRemoveHistoryItem(client, _ref4) {
  var itemType, itemId, userId;
  return regeneratorRuntime.wrap(function doSearchPanelRemoveHistoryItem$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          itemType = _ref4.itemType, itemId = _ref4.itemId;
          _context5.next = 3;
          return select(userIdSelector);

        case 3:
          userId = _context5.sent;
          _context5.prev = 4;

          if (!(itemType === ITEM_TYPES.location)) {
            _context5.next = 10;
            break;
          }

          _context5.next = 8;
          return call(client.search.location.removeHistoryItem, userId, itemId);

        case 8:
          _context5.next = 12;
          break;

        case 10:
          _context5.next = 12;
          return call(client.search.keyword.removeHistoryItem, userId, itemId);

        case 12:
          _context5.next = 17;
          break;

        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5["catch"](4);
          logger.error('Failed while removing search box history item', _context5.t0);

        case 17:
          _context5.next = 19;
          return call(doLoadPanelData, client, true);

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[4, 14]]);
}
export function doAutocomplete(panel, client, _ref5) {
  var value, openPanel, _ref6, lat, lon;

  return regeneratorRuntime.wrap(function doAutocomplete$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          value = _ref5.value;
          _context6.prev = 1;
          _context6.next = 4;
          return select(selectOpenPanel);

        case 4:
          openPanel = _context6.sent;

          if (!(openPanel === panel && !isBlank(value))) {
            _context6.next = 25;
            break;
          }

          _context6.next = 8;
          return call(delay, 250);

        case 8:
          _context6.next = 10;
          return select(selectActiveLocation);

        case 10:
          _ref6 = _context6.sent;
          lat = _ref6.lat;
          lon = _ref6.lon;

          if (!(panel === PANEL_NAMES.keyword)) {
            _context6.next = 20;
            break;
          }

          _context6.next = 16;
          return call(fetchEntityIfNeeded, keywordAutocomplete, [client, value, {
            lat: lat,
            lon: lon
          }], {
            key: value
          });

        case 16:
          _context6.next = 18;
          return put(setKeywordKey(value));

        case 18:
          _context6.next = 25;
          break;

        case 20:
          if (!(panel === PANEL_NAMES.location)) {
            _context6.next = 25;
            break;
          }

          _context6.next = 23;
          return call(fetchEntity, searchLocationAutocomplete, [client, {
            query: value,
            near: {
              lat: lat,
              lon: lon
            }
          }], {
            key: value
          });

        case 23:
          _context6.next = 25;
          return put(setLocationKey(value));

        case 25:
          _context6.next = 30;
          break;

        case 27:
          _context6.prev = 27;
          _context6.t0 = _context6["catch"](1);
          logger.error('Failed while fetching autocomplete data', _context6.t0);

        case 30:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 27]]);
}
export function setActivityKeyword(activity) {
  return regeneratorRuntime.wrap(function setActivityKeyword$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.t0 = put;
          _context7.t1 = setKeyword;
          _context7.t2 = activity;
          _context7.t3 = call;
          _context7.t4 = selectKeywordAutocompleteValueInLayout;
          _context7.next = 7;
          return select(selectDataFromResultsLayout);

        case 7:
          _context7.t5 = _context7.sent;
          _context7.next = 10;
          return (0, _context7.t3)(_context7.t4, _context7.t5);

        case 10:
          _context7.t6 = _context7.sent;
          _context7.t7 = {
            id: _context7.t2,
            name: _context7.t6
          };
          _context7.t8 = (0, _context7.t1)(_context7.t7);
          _context7.next = 15;
          return (0, _context7.t0)(_context7.t8);

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
export function watchSearchBoxSagas(client, props) {
  return regeneratorRuntime.wrap(function watchSearchBoxSagas$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return fork(takeEvery, SEARCH_PANEL_ITEM_SELECTED, doSearchPanelItemSelected, client);

        case 2:
          _context8.next = 4;
          return fork(takeEvery, SEARCH_PANEL_REMOVE_HISTORY_ITEM, doSearchPanelRemoveHistoryItem, client);

        case 4:
          _context8.next = 6;
          return fork(takeEvery, SET_OPEN_PANEL, doLoadPanelData, client, false);

        case 6:
          _context8.next = 8;
          return fork(takeEvery, SET_OPEN_PANEL, doTrackSearchBoxSelected, props.optimizelyEventTrackingName);

        case 8:
          _context8.next = 10;
          return fork(takeLatest, SET_KEYWORD_VALUE, doAutocomplete, PANEL_NAMES.keyword, client);

        case 10:
          _context8.next = 12;
          return fork(takeLatest, SET_LOCATION_VALUE, doAutocomplete, PANEL_NAMES.location, client);

        case 12:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}